var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.boolUser)?_c('mainTran',{attrs:{"data_new":_vm.data,"boolUser_new":_vm.boolUser}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }